import { TopPage } from "@/components/elements/TopPage";
import { InformationListTop } from "@/features/information/components/InformationListTop";
import { InformationTable } from "@/features/information/components/InformationTable";

import { Box, Stack } from "@mui/material";
import { FC, useEffect } from "react";
import { styled } from "@mui/system";
import { useLocation, useNavigate } from "react-router-dom";
import { useInformationListSessionStorage } from "@/hooks/useInformationListSessionStorage";
import { useIsPageParamValid, useSanitizedPageParam } from "@/hooks/useSanitizedPageParam";

type TInformationPageProps = {};

export const InformationPage: FC<TInformationPageProps> = () => {
  useSanitizedPageParam();

  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const { saveState, getState } = useInformationListSessionStorage();
  const isValidPage = useIsPageParamValid();

  useEffect(() => {
    const savedState = getState();
    if (!savedState?.searchParams) return;
    if (search) return;

    navigate(`${pathname}?${savedState.searchParams}`, { replace: true });
  }, [pathname, search, navigate, getState]);

  useEffect(() => {
    if (!isValidPage) return;

    const currentState = getState();
    saveState({
      searchParams: search.startsWith("?") ? search.slice(1) : search,
      selectedKeys: currentState?.selectedKeys,
    });
  }, [search, saveState, getState, isValidPage]);

  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <TopPage title="お知らせ一覧" enablePageBack={false} />
        <Stack gap={3}>
          <InformationListTop />
          <InformationTableStyle>
            <Stack>
              <InformationTable />
            </Stack>
          </InformationTableStyle>
        </Stack>
      </Box>
    </Stack>
  );
};

const InformationTableStyle = styled(Stack)`
  background: #ffffff;
  padding: 24px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #e6e7e8;
`;
